<template>
   <div class="scroll-prompt d-inline-flex flex-column align-items-center">
      <span class="scroll-prompt-text d-block text-uppercase knockout-lite">Start Scrolling</span>
      <svg class="large-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 15 123.96" height="126" width="13">
         <path d="M14.9,117a1.09,1.09,0,0,0-.86-.53,1.22,1.22,0,0,0-.43,0,1.13,1.13,0,0,0-.32.15l-.11.08L8.5,120.83V0h-2V120.83l-4.67-4.08-.05,0-.12-.08a1.16,1.16,0,0,0-.33-.13,1.22,1.22,0,0,0-.29,0,1.11,1.11,0,0,0-.9.48.86.86,0,0,0-.12.3.82.82,0,0,0,0,.13v.06a.82.82,0,0,0,0,.13.87.87,0,0,0,.16.35,1.17,1.17,0,0,0,.14.15l6.43,5.62.11.08.19.1a1.22,1.22,0,0,0,.92,0l.19-.1.11-.08,6.43-5.62.1-.1a.88.88,0,0,0,.2-.41.82.82,0,0,0,0-.32A.86.86,0,0,0,14.9,117Z"
               style="fill:#3dc2cb;fill-rule:evenodd"/>
      </svg>
      <svg class="small-arrow" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      	 viewBox="0 0 10 40" style="enable-background:new 0 0 10 40;" xml:space="preserve" width="10px">
        <path class="st0" d="M9.9,34.4C9.8,34.2,9.6,34,9.4,34c-0.1,0-0.2,0-0.3,0c-0.1,0-0.2,0.1-0.2,0.1c0,0,0,0-0.1,0.1l-2.9,3.1V0h-2v37
        	l-2.7-2.8l0,0c0,0,0,0-0.1-0.1C1,34.1,1,34,0.9,34c-0.1,0-0.1,0-0.2,0c-0.2,0-0.5,0.2-0.6,0.4c0,0.1-0.1,0.2-0.1,0.2
        	c0,0,0,0.1,0,0.1v0.1c0,0,0,0.1,0,0.1c0,0.1,0.1,0.2,0.1,0.3c0,0,0.1,0.1,0.1,0.1l4.3,4.5c0,0,0,0,0.1,0.1c0,0,0.1,0.1,0.1,0.1
        	c0.2,0.1,0.4,0.1,0.6,0c0,0,0.1,0,0.1-0.1c0,0,0,0,0.1-0.1l4.3-4.5c0,0,0,0,0.1-0.1C9.9,35.1,10,35,10,34.9c0-0.1,0-0.2,0-0.3
        	C10,34.6,10,34.5,9.9,34.4z"/>
      </svg>
   </div>
</template>

<script>

    export default {
        name: 'ScrollPrompt',
        data() {
            return {}
        }
    }
</script>

<style lang="scss">
   @import '../scss/the-goods';

   .scroll-prompt {
      font-size  : 1.5rem;
      position   : fixed;
      top        : 90vh;
      transform  : translateY(-100%);
      margin-top : 20px;

      &-text {
         letter-spacing : 0.135em;
         margin         : 0 0 1rem 0;

         @include screen-xs-sm {
            display : none !important;
         }
      }

      .large-arrow {
         @include screen-xs-sm {
            display : none;
         }
      }

      .small-arrow {
         fill   : #3DC2CB;
         margin : 15px 0px 0px 40px;

         @include screen-sm-md-lg-xl {
            display : none;
         }
      }

   }

   .portrait-mode {
      .scroll-prompt {
         position  : relative;
         top       : auto;
         transform : none;
      }
   }
</style>



// WEBPACK FOOTER //
// src/components/ScrollPrompt.vue